import { useAtom, useAtomValue } from 'jotai';
import { RESET } from 'jotai/utils';
import { useCallback, useEffect, useMemo } from 'react';

import {
  atomCampaignList,
  atomLoadingProcess,
  atomRefetchAllData,
  atomTotalsProcess,
} from '@/src/modules/CampaignsModule/atoms/campaignAtom';
import { useCampaignsStateContext } from '@/src/modules/CampaignsModule/contexts/CampaignsContext';
import { ICampaignListPayload } from '@/src/modules/CampaignsModule/interfaces/Campaigns';

import { useCampaign } from './useCampaigns';
import { useStrategies } from './useStrategies';

export const useCampaignData = () => {
  const { getList } = useCampaign();
  const { getStrategies } = useStrategies();
  const { pageSize, pageIndex, filterBy, orderBy } = useCampaignsStateContext();

  const [refetchAllData, setRefetchAllData] = useAtom(atomRefetchAllData);
  const campaignList = useAtomValue(atomCampaignList);
  const loadingProcess = useAtomValue(atomLoadingProcess);
  const totalsCampaignList = useAtomValue(atomTotalsProcess);

  const filtersCount = useMemo(() => Object.keys(filterBy).length, [filterBy]);

  const getListCampaigns = useCallback(() => {
    const payload: ICampaignListPayload = {
      page: pageIndex,
      limit: pageSize,
      ...filterBy,
      ...orderBy,
    };
    void getList(payload);
  }, [filterBy, getList, orderBy, pageIndex, pageSize]);

  useEffect(() => {
    if (refetchAllData) {
      getListCampaigns();
      void getStrategies();
      setRefetchAllData(RESET);
    }
  }, [getListCampaigns, getStrategies, refetchAllData, setRefetchAllData]);

  useEffect(() => getListCampaigns(), [getListCampaigns]);

  return {
    campaignList,
    loadingProcess,
    totalsCampaignList,
    filtersCount,
  };
};
